import axios, { type AxiosInstance } from "axios";
import type { AxiosRequestConfig } from "axios";

export const createApiClient = (
  { serverUrl }: { serverUrl: string },
  axiosConfig: AxiosRequestConfig,
): AxiosInstance => {
  return axios.create({ baseURL: serverUrl, ...axiosConfig });
};
